import { render, staticRenderFns } from "./PrimaryLogoDisplay.vue?vue&type=template&id=cf927846&scoped=true&"
import script from "./PrimaryLogoDisplay.vue?vue&type=script&lang=js&"
export * from "./PrimaryLogoDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryLogoDisplay.vue?vue&type=style&index=0&id=cf927846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf927846",
  null
  
)

export default component.exports